import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function Hero() {
  return <section className="w-full bg-dark min-h-screen flex items-center justify-center px-4 py-16 md:py-24" data-id="element-64">
      <div className="max-w-4xl w-full" data-id="element-65">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center space-y-8" data-id="element-66">
          <h1 className="font-bebas text-5xl md:text-7xl lg:text-8xl leading-tight text-white tracking-wide" data-id="element-67">
            PROTOCOLO DOPAMINA LIMPIA: El Reinicio Biológico de 7 Días
          </h1>

          <h2 className="font-inter text-xl md:text-2xl lg:text-3xl text-text/90 font-light max-w-3xl mx-auto" data-id="element-68">
            Recupera tu enfoque, destruye la niebla mental y vuelve a ser el
            dueño de tu voluntad en solo 168 horas.
          </h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="pt-8 space-y-6 text-left max-w-2xl mx-auto" data-id="element-69">
            <p className="font-inter text-base md:text-lg leading-relaxed text-text/80" data-id="element-70">
              Miras el reloj. Son las 11:30 PM. Has pasado las últimas tres
              horas saltando de video en video, de aplicación en aplicación,
              buscando algo que ni siquiera sabes qué es.
            </p>

            <p className="font-inter text-base md:text-lg leading-relaxed text-text/80" data-id="element-71">
              Sientes ese vacío en el pecho. No es cansancio físico, es algo
              peor: es anestesia. Sabes que tienes potencial, sabes que deberías
              estar haciendo otras cosas, pero tu voluntad está muerta bajo el
              peso de un algoritmo de mil millones de dólares.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="pt-8" data-id="element-72">
            <a href="#offer" className="group bg-teal hover:bg-teal/90 text-dark font-inter font-bold text-lg px-10 py-5 rounded-lg transition-all duration-300 transform hover:scale-105 inline-flex items-center gap-3" data-id="element-73">
              QUIERO MI REINICIO DE 7 DÍAS
              <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-74" />
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}